import React, { useEffect, useState } from "react";

import { get } from "lodash";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { Modal, ModalBody, Table, Input, Button,ModalHeader } from "reactstrap";

// import ButtonWithLoader from "../ButtonWithLoader";
import PaymentDetailsFirst from "./PaymentDetailsFirst";
import PaymentDetailsSecond from "./PaymentDetailsSecond";
import { signOroBond, createPurchaseOrder } from "../services/waitlist-service";
import { utils } from "../../core/helpers/utils";

export default function NaviPaymentDetails(props) {
  window.scrollTo(0, 0);

  const [isSigned, setIsSigned] = useState(false);
  const [openScreen, setOpenScreen] = useState(false);
  const [marksView, setMarksView] = useState([true, false, false]);
  const [marksDone, setMarksDone] = useState(new Array(3).fill(false));
  const [loader, setLoader] = useState(false);
  const [checked, setChecked] =useState(true);
  const [product, setProduct] = useState(props?.product); 

  useEffect(()=>{
    if(props?.userInRfqCug){
      setChecked(false)
    }
  },[props?.userInRfqCug])

  useEffect(()=>{
    if(props?.userInRfqCug){
      setChecked(false)
    }
  },[props?.userInRfqCug])

  const moveRight = (current) => {
    let view = marksView;
    let done = marksDone;
    if (current < 2) {
      view[current] = false;
      done[current] = true;
      view[current + 1] = true;
    } else {
      view[current] = false;
      done[current] = true;
    }
    setMarksDone([...done]);
    setMarksView([...view]);
  };

  const handleChecked = () => {
    setChecked(!checked);
  }

  const goToPayment = async (demat, paymentFlow) => {
    try {
      // debugger;
      setLoader(true);
      if (props.custId && props.units) {
        var res;
        if (props?.ucc?.bse?.uccCreated && props?.userInRfqCug) {
          console.log(props?.openPaymentRtgs())
          console.log(props.togglePaymentModal)
        }else if (props?.ucc?.nse?.uccCreated && props?.userInRfqCug) {
          console.log(props?.openPaymentRtgs())
          console.log(props.togglePaymentModal)
        } else {
          try {
            res = await createPurchaseOrder(
              {
                demat: demat,
                units: props.units,
                custId: props.custId,
                pan: props.pan ? props.pan : get(props, "thirdPartyData.pan", ""),
              },
              product,
              { "X-product": `orobonds:${product}` },
              props.isin
            ).then(result => {
              return utils.parsePayload(result);
            });
          } catch (createOrderError) {
            console.error("Error in createPurchaseOrder:", createOrderError);
          }
        }
  
        if (res && res.success && res.data) {
          let payload = {
            Platform: "web",
            orderId: get(res, "data.orderId", ""),
            pan: props.pan ? props.pan : get(props, "thirdPartyData.pan", ""),
            email: get(props, "thirdPartyData.email", ""),
          };
  
          let eSigningUrlRes = await signOroBond(payload, {
            "X-product": `orobonds:${product}`,
          }).than(response=> {
            return utils.parsePayload(response);
          });
  
          if (eSigningUrlRes && eSigningUrlRes.success) {
            if (
              eSigningUrlRes.data &&
              eSigningUrlRes.data.eSigningUrl
            ) {
              window.history.pushState(
                null,
                null,
                '/' + process.env.REACT_APP_DASHBOARD_PREFIX + '/#/biddeasy-asset'
              );
              window.location.replace(
                get(eSigningUrlRes, "data.eSigningUrl", "")
              );
            } else {
              setLoader(false);
              toast.error("E-signing URL is not available.");
            }
          } else {
            setLoader(false);
            toast.error(
              eSigningUrlRes.message
                ? eSigningUrlRes.message
                : "Something went wrong, unable to create the Digio e-sign document!"
            );
          }
        } else {
          setLoader(false);
          toast.error("Something went wrong, unable to create purchase order!");
        }
      } else {
        setLoader(false);
        toast.error("Missing customer ID or units.");
      }
    } catch (err) {
      setLoader(false);
      toast.error("Something went wrong, unable to create purchase order!");
    }
  };

  const updateIsSigned = () => {
    setOpenScreen(true);
    setIsSigned(true);
  };

  const toggleScreen = () => {
    setOpenScreen(!openScreen);
    let view = new Array(3).fill(false);
    let done = marksDone;
    done[1] = true;
    setMarksView([...view]);
    setMarksDone([...done]);
  };

  return (
    <Modal
      size="xl"
      className="navi-otp-modal overflow-hidden"
      backdrop="static"
      isOpen={props.paymentModalOpen}
      toggle={props.togglePaymentModal}
      contentClassName="h-100"
      zIndex={9999}
    >
    <ModalHeader
      isOpen={props.paymentModalOpen}
      toggle={props.togglePaymentModal}
    />
      <ModalBody>
        <div className="overflow-y h-100 scrolled-body">
        <div className="payment-modal-body">
          <div className="navi-logo-div">
            <img src={process.env.REACT_APP_IMAGES_PATH + "biddeasy.webp"} />
            <div className="divider" />
            <img className="second-img" src={props.logoUrl} />
          </div>
          <div className="mark-main">
            <div className="marks">
            <img src={process.env.REACT_APP_IMAGES_PATH + "txMark.webp"} />
              {marksView[0] && <div className="mdi-holder"></div>}
              {marksDone[0] && <div className="mdi-holder"></div>}
              {!marksView[0] && !marksDone[0] && <div className="rounded" />}
              <div className="text">Confirm your transaction details</div>
            </div>
            <div className="marks">
            {!props?.ucc?.bse?.uccCreated && !props?.userInRfqCug ? <><img src={process.env.REACT_APP_IMAGES_PATH + "signMark.webp"} /> 
              {marksView[1] && <div className="mdi-holder"></div>}
              {marksDone[1] && <div className="mdi-holder"></div>}
              {!marksView[1] && !marksDone[1] && <div className="rounded" />} 
              <div className="text">Review & sign your agreement</div></>: null}
            </div>
            <div className="marks">
            <img src={process.env.REACT_APP_IMAGES_PATH + "upiMark.webp"} />
              {marksView[2] && <div className="mdi-holder"></div>}
              {marksDone[2] && <div className="mdi-holder"></div>}
              {!marksView[2] && !marksDone[2] && <div className="rounded" />}
              <div className="text">Transfer funds</div>
            </div>
          </div>
          {(marksView[0] || isSigned) && (
            <PaymentDetailsFirst
              productname={props?.productname}
              uirr={props.irr}
              units={props.units}
              demat={props.demat}
              amount={props.amount}
              moveRight={moveRight}
              oppName={props.oppName}
              benefit={props.benefit}
              referralBenefit={props.referralBenefit}
              goToPayment={goToPayment}
              userAmount={props.userAmount}
              benefitPerc={props.benefitPerc}
              loader={loader}
              checked={checked}
              product={product}
              userEmail={props.userEmail}
              ytm={props.ytm}
              isTxnAllowed={props.isTxnAllowed}
              ucc={props?.ucc}
              cug={props?.cug}
              investmentAmount={props?.investmentAmount}
              userInRfqCug={props?.userInRfqCug}
              rfqExchangeType={props.rfqExchangeType}
              handleChecked={handleChecked}
            />
          )}
          {/* {(marksView[0] || isSigned) && (
            <p className="footer">
            <input type = "checkbox"
              defaultChecked={checked}
              onChange={() => setChecked(!checked)}
              />&nbsp;
              I accept to &nbsp;
              <a className="text-secondary" target="_blank" href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}><b>Terms, Conditions and Disclaimer</b></a>
            </p>
          )} */}
          {marksView[1] && (
            <PaymentDetailsSecond
              freq="Monthly"
              isin="ISIN9876543"
              faceVal="₹ 1,000"
              isSigned={isSigned}
              depository="NSDL, CDSL"
              openScreen={openScreen}
              maturity="08/12/2023"
              toggleScreen={toggleScreen}
              startDate="30- Septembr-2022"
              issuer="NAVI Finserv Private Limited"
              security="Secured, Rated A/Stable, Listed"
            />
          )}
          {marksView[1] && (
            <div className="btn-sign">
              <Button onClick={updateIsSigned}>Sign now</Button>
            </div>
          )}
          </div>
        </div>
      </ModalBody>
      <ToastContainer />
    </Modal>
  );
}